import React from "react";
import { Box } from "@chakra-ui/react";
import BuyerListing from "./BuyerListing";
import BuyerDrawer from "./drawer-forms/BuyerDrawer";
import { useDelete } from "../../hooks/api-call";
import { useState } from "react";
import { useAuth } from "../../auth/AuthProvider";
import { baseURL } from "../../hooks/helper";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { createTheme, ThemeProvider } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: 'light',
    background: { default: '#fff' },
  },
});

const BuyerDashboard = () => {
  const { token } = useAuth();
  const headers = {
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const [columnFilters, setColumnFilters] = useState([]);

  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 20 });

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedBuyerForEdit, setSelectedBuyerForEdit] = useState(false);

  const {
    data: { content = [], totalElements } = {},
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['trucks-list', { columnFilters, pagination }],
    queryFn: async () => {
      const fetchURL = new URL(`${baseURL}/buyer/search`);
      fetchURL.searchParams.set('page', `${pagination.pageIndex}`);
      fetchURL.searchParams.set('size', `${pagination.pageSize}`);
      fetchURL.searchParams.set('filters', JSON.stringify(columnFilters ?? []));
      // fetchURL.searchParams.set('sortParams', JSON.stringify(sorting ?? []));
      const response = await fetch(fetchURL.href, { headers: headers });
      return response.json();
    },
    placeholderData: keepPreviousData,
  });

  const { deleteData } = useDelete();

  const handleRemoveTruck = async (buyerId) => {
    await deleteData(null, `buyers/${buyerId}`);
  };

  const handleEditOpen = (buyer) => {
    setIsDrawerOpen(true);
    setSelectedBuyerForEdit(buyer);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box>
          <Box pl="5" pr="5">
            {/* <BuyerSearchHeading setIsDrawerOpen={setIsDrawerOpen} /> */}
            {/* <BuyerFilters fetchBuyersData={fetchBuyersData} /> */}
            <BuyerListing
              handleRemoveTruck={handleRemoveTruck}
              isLoading={isLoading}
              content={content}
              pagination={pagination}
              setPagination={setPagination}
              pageSize={pagination.pageSize}
              totalPages={totalElements}
              handleEditOpen={handleEditOpen}
              refetch={refetch}
              setIsDrawerOpen={setIsDrawerOpen}
              setColumnFilters={setColumnFilters}
            />
          </Box>

          {isDrawerOpen && (
            <BuyerDrawer
              defaultValues={selectedBuyerForEdit}
              setIsDrawerOpen={setIsDrawerOpen}
              setPagination={setPagination}
              setSelectedBuyerForEdit={setSelectedBuyerForEdit}
            />
          )}
        </Box>
      </ThemeProvider>
    </>
  );
};

export default BuyerDashboard;